// React
import React from 'react';

// Packages

// Utilities

import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsProductsAndInventionsDetails } from 'components/_cardContents/resultsProductsAndInventions/resultsProductsAndInventions';

const Name = CONSTANTS.RESULTS.PRODUCTS_AND_INVENTIONS;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Intervention_Method__c',
        fieldName: 'Intervention_Method__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Intervention_Method__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsProductsAndInventionsDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, pickList } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        console.log('getItemData', formData);
        const {
            Intervention_Method__c,
            Clinical_Trial_Id__c,
            Clinical_Phase__c,
            Dates,
        } = formData;

        // Data for sf
        return {
            Intervention_Method__c,
            Clinical_Trial_Id__c,
            Clinical_Phase__c,
            Result_Start_Date__c: Dates?.from,
            Result_End_Date__c: Dates?.to,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        const isClinicalTrial =
            props?.form?.getValues()?.Intervention_Method__c ===
            'Clinical trial';
        const isFieldTrial =
            props?.form?.getValues()?.Intervention_Method__c === 'Field trial';
        return [
            {
                type: 'Text',
                name: 'Clinical_Trial_Id__c',
                object: object.config(
                    'Initiative_Result__c.Clinical_Trial_Id__c'
                ),
                maxLength: 80,
            },
            ...(isFieldTrial
                ? [
                      {
                          type: 'Select',
                          name: 'Field_Trial_Type__c',
                          object: object.config(
                              'Initiative_Result__c.Field_Trial_Type__c'
                          ),
                          options: pickList(
                              'Initiative_Result__c.Field_Trial_Type__c'
                          ),
                      },
                  ]
                : []),
            ...(isClinicalTrial
                ? [
                      {
                          type: 'Select',
                          name: 'Clinical_Phase__c',
                          object: object.config(
                              'Initiative_Result__c.Clinical_Phase__c'
                          ),
                          options: pickList(
                              'Initiative_Result__c.Clinical_Phase__c'
                          ),
                      },
                  ]
                : []),
            {
                type: 'DateRange',
                name: 'Dates',
                object: object.config('Initiative_Result__c.Dates'),
                labelFrom: object.label(
                    'Initiative_Result__c.Result_Start_Date__c'
                ),
                labelTo: object.label(
                    'Initiative_Result__c.Result_End_Date__c'
                ),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Products_And_Inventions',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Intervention_Method__c,
        Clinical_Trial_Id__c,
        Clinical_Phase__c,
        Result_Start_Date__c,
        Result_End_Date__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Intervention_Method__c', Intervention_Method__c);

    // Dates for field
    form.setValue('Dates', {
        from: Result_Start_Date__c,
        to: Result_End_Date__c,
    });

    // Dates for view only
    form.setValue('Result_Start_Date__c', Result_Start_Date__c);
    form.setValue('Result_End_Date__c', Result_End_Date__c);

    form.setValue('Clinical_Trial_Id__c', Clinical_Trial_Id__c);
    form.setValue('Clinical_Phase__c', Clinical_Phase__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
